import { useState,useEffect, useRef } from 'react'
import "./header.css"
import mainLogo from "../../assets/images/logo.svg"

const Header = () => {
    const [activeNav, sectActiveNav] = useState(0);
    const [menuOpen, setMenuOpen] = useState(false);
    const deskHeader = useRef();
    let lastScroll = 0;
    const headerSticky = () => {
        const currentScroll = window.pageYOffset;
        if (currentScroll <= 0 && deskHeader.current) {
            deskHeader.current.classList.remove("hide-scroll-header");
            return;
        }
        if (currentScroll > lastScroll && deskHeader.current) {
            deskHeader.current.classList.add("hide-scroll-header");
        } else if (currentScroll < lastScroll && deskHeader.current) {
            deskHeader.current.classList.remove("hide-scroll-header");
        }
        lastScroll = currentScroll;
    }
    useEffect(() => {
        window.addEventListener("scroll", headerSticky);
    });

    return (
        <header ref={deskHeader} className="web-header" data-aos="fade-down" data-aos-offset="0" data-aos-duration="1100" data-aos-delay="300">
            <div className="header-container">
                <div className="logo-part">
                    <a href="/"><img src={mainLogo} alt="G-Fox" /></a>
                </div>
                <nav className={menuOpen ? 'opened-navs nav-sec' : 'nav-sec'}>
                    <a href="/" className="mob-logo"><img src={mainLogo} alt="G-Fox" /></a>
                    <ul>
                        <li><a className={activeNav === 6 ? 'active-nav' : ''} onClick={() => { sectActiveNav(6); setMenuOpen(false) }} href="#join">JOIN</a></li>
                        <li><a className={activeNav === 0 ? 'active-nav' : ''} onClick={() => { sectActiveNav(0); setMenuOpen(false) }} href="#story">Story</a></li>
                        <li><a className={activeNav === 2 ? 'active-nav' : ''} onClick={() => { sectActiveNav(2); setMenuOpen(false) }} href="#play">Play</a></li>
                        <li><a className={activeNav === 1 ? 'active-nav' : ''} onClick={() => { sectActiveNav(1); setMenuOpen(false) }} href="#utility">Utility</a></li>
                        <li><a className={activeNav === 3 ? 'active-nav' : ''} onClick={() => { sectActiveNav(3); setMenuOpen(false) }} href="#roadMap">Road map</a></li>
                        <li><a className={activeNav === 4 ? 'active-nav' : ''} onClick={() => { sectActiveNav(4); setMenuOpen(false) }} href="#faq">Faq</a></li>
                        <li><a className={activeNav === 5 ? 'active-nav' : ''} onClick={() => { sectActiveNav(5); setMenuOpen(false) }} href="#team">Team</a></li>
                        <li><button className={`connect-wallet`} onClick={() => { sectActiveNav(null); setMenuOpen(false) }}>Connect Wallet</button></li>
                    </ul>
                    <div className="nav-bottom pt-2">
                        <p>Design & Developed by <a className="primary-anchor" href="https://smashcode.dev/">Smash Code</a></p>
                    </div>
                </nav>
                <div className="menu-btn">
                    <div className={menuOpen ? 'ham-burg-opened' : ''} id="nav-icon2" onClick={() => setMenuOpen(!menuOpen)}>
                        <span></span>
                        <span></span>
                        <span></span>
                        <span></span>
                        <span></span>
                        <span></span>
                    </div>
                </div>
            </div>
            <div className={`nav-shadow  ${menuOpen ? 'show-shadow' : ''}`}
                onClick={() => setMenuOpen(false)}></div>
        </header>
    )
}

export default Header
